import classNames from 'classnames';
import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { SmoLanguage } from '../../../../../../Models/Smo/SmoLanguage';
import { SmoMoon } from '../../../../../../Models/Smo/SmoMoon';
import WidgetSelectors from '../../../../../../Modules/Redux/Pages/Widget/WidgetSelectors';
import { isBetween } from '../../../../../../Utils/Maths';
import { Optional } from '../../../../../../Utils/Types';

export const WidgetNextMoon: FunctionComponent = () => {
  const nextMoon: Optional<SmoMoon> = useSelector(WidgetSelectors.nextMoon);
  const moonLanguage: SmoLanguage = useSelector(WidgetSelectors.moonLanguage);
  const primaryColor: string = useSelector(WidgetSelectors.primaryColor);
  const secondaryColor: string = useSelector(WidgetSelectors.secondaryColor);
  const scale: number = useSelector(WidgetSelectors.scale);

  return (
    <>
      {nextMoon ? (
        <div className={classNames('v-stack items-start', isBetween(scale, 0, 50) ? 'space-y-1.5' : 'space-y-3')}>
          <h2
            className="text-tint font-bold tracking-wide transition-color-widget"
            style={{ fontSize: `${10 + scale}px`, lineHeight: '100%', color: secondaryColor }}
          >
            Next
          </h2>
          <h3
            className="text-tint font-bold transition-color-widget"
            style={{ fontSize: `${17 + scale}px`, lineHeight: '100%', color: primaryColor }}
          >
            {nextMoon?.names[moonLanguage]}
          </h3>
        </div>
      ) : undefined}
    </>
  );
};
